import React from "react";
import "./TitleBar.scss";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

const TitleBar = (props) => {
  return (
    <div className="title-bar">
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        justifySelf="center"
      >
        <Box>{""}</Box>
        <Box className="title-bar-text-box" style={{ marginTop: "15px" }}>
          {props.title}
        </Box>
        <Box width="auto" style={{ marginTop: "15px" }}>
          {props.delete_button && (
            <Button
              color="inherit"
              aria-label="Delete"
              data-client_id={props.client_id}
              data-trip_id={props.trip_id}
              data-effort_id={props.effort_id}
              data-catch_id={props.catch_id}
              data-sales_id={props.sales_id}
              onClick={(e) => props.delete_button(e)}
              startIcon={<DeleteIcon />}
              style={{ backgroundColor: "#0099d8" }}
            />
          )}
        </Box>
      </Box>
    </div>
  );
};
export default TitleBar;
